/*
 * @Author: liuxw@codoon.com 
 * @Date: 2020-07-03 13:46:10 
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-09 15:22:00
 * @Content: 
 */


export default {
    formItemWrapper: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        height: "50px",
        fontFamily: "PingFang SC Regular",
        fontSize: "14px",
        color: "rgba(34,34,34,1)",
        padding: "0 16px",
        borderBottom: "1px solid rgba(242,242,242,1)",
    },
    formItemLabel: {
        paddingRight: "20px",
        width: "76px",
        whiteSpace: "nowrap" as "nowrap",
    },
    formItemContent: {
        flex: 1,
    },
    arrowIconWrapper: {
        width: "22px",
        height: "22px",
    },
}